/* === KOPFZEILE: SYMBOLLEISTE HAENGT AM MENUE (17.09.2026) ====================
   Die Symbolleiste soll genau so weit hinter dem letzten Menuepunkt stehen, wie die
   Menuepunkte untereinander auseinanderliegen - nicht mit einem festen Pixelwert.

   Warum gemessen und nicht in CSS gerechnet: Die Menuebreite haengt an Schriftgroesse und
   Zeichenzahl und schwankt zwischen den Aufloesungen um rund 60px (gemessen: Menueende
   307px vom rechten Headerrand bei 1280, 365px bei 1440 und 1920). Ein fester rem-Wert
   trifft deshalb immer nur eine Groesse - genau daran lag die Ueberlappung bei 1280.

   Gemessen wird am SICHTBAREN: rechte Kante des letzten Menuetextes, linke Kante des
   ersten Symbols (der Lupe). Die Trefferflaeche der Symbole ist 44px breit, das Zeichen
   darin nur 20 bis 27px - ohne diesen Ausgleich stuende die Lupe optisch zu weit weg.

   Gesetzt werden zwei Werte:
     --kopf-leiste-links    Pixelposition der Leiste (base.css setzt left darauf)
     --header-group-shift   der vorhandene Regler: rueckt das Menue um die halbe
                            Zusatzbreite nach links, damit die Gruppe aus Menue und
                            Symbolen mittig unter dem Logo bleibt
   Geschrieben wird nur bei echter Aenderung (0,5px Toleranz), sonst laeuft der
   MutationObserver in eine Schleife.
   ========================================================================== */
(() => {
  const MIN_BREITE = 1280;   // darunter steckt das Menue im Hamburger, dann gilt CSS allein

  // Gemessen wird der TEXTKNOTEN, nicht das Element und nicht "Kante minus Polster".
  // Beide Abkuerzungen liefern in diesem Theme 0: Ab 1280px haben die Menuepunkte kein
  // Polster, und ihre Kaesten stossen aneinander (gemessen: 612|612, 677|677) - der
  // sichtbare Abstand kommt daher, dass der Text im Kasten zentriert ist und ihn nicht
  // ausfuellt ("Start" = 38px Text in 65px Kasten). Mit Abstand 0 klebte die Leiste am
  // Menue und ueberlappte es um den Innenrand des Symbols.
  const textKasten = (el) => {
    const bereich = document.createRange();
    const lauf = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    let erster = null;
    let letzter = null;
    while (lauf.nextNode()) {
      if (!lauf.currentNode.nodeValue.trim()) continue;
      if (!erster) erster = lauf.currentNode;
      letzter = lauf.currentNode;
    }
    if (!erster) return el.getBoundingClientRect();
    bereich.setStart(erster, 0);
    bereich.setEnd(letzter, letzter.nodeValue.length);
    const b = bereich.getBoundingClientRect();
    return b.width > 0 ? b : el.getBoundingClientRect();
  };

  const messen = () => {
    const header = document.querySelector('.header.header--top-center');
    const leiste = header && header.querySelector('.header__icons');
    const menue = header && header.querySelector('.header__inline-menu');
    if (!header || !leiste || !menue) return null;
    if (window.innerWidth < MIN_BREITE || getComputedStyle(menue).display === 'none') return null;

    const punkte = Array.from(menue.querySelectorAll('a, summary'))
      .filter((e) => !e.closest('.header__submenu') && e.getBoundingClientRect().width > 0);
    if (punkte.length < 2) return null;
    const kaesten = punkte.map(textKasten).sort((a, b) => a.left - b.left);

    // Abstand zwischen zwei Menuepunkten: der kleinste in derselben Zeile - das ist der
    // Rhythmus des Menues (groessere Werte kaemen von Umbruechen).
    const zeile = kaesten.filter((b) => Math.abs(b.top - kaesten[0].top) < 5);
    let abstand = Infinity;
    for (let i = 1; i < zeile.length; i++) abstand = Math.min(abstand, zeile[i].left - zeile[i - 1].right);
    if (!isFinite(abstand) || abstand < 0) return null;

    const letzter = zeile[zeile.length - 1];
    // Innenrand des ersten Symbols: Abstand von der Leistenkante zum sichtbaren Zeichen.
    // Auch hier nur Zeichen INNERHALB der Leiste (siehe Hinweis unten zum Suchfenster).
    const lbox = leiste.getBoundingClientRect();
    const eigene = Array.from(leiste.querySelectorAll('svg'))
      .map((s) => s.getBoundingClientRect())
      .filter((g) => g.width > 0 && g.height > 0 && g.left >= lbox.left - 2 && g.right <= lbox.right + 2)
      .sort((a, b) => a.left - b.left);
    const glypheOffset = eigene.length ? eigene[0].left - lbox.left : 0;
    return {
      header, leiste, menue, abstand, glypheOffset,
      // Breite des Menues von der linken Textkante des ersten bis zur rechten des letzten
      // Punktes - unabhaengig davon, wohin das Menue gerade verschoben ist.
      menueBreite: letzter.right - zeile[0].left
    };
  };

  const setzen = () => {
    const m = messen();
    const wurzel = document.documentElement;
    if (!m) {
      // Ausserhalb des Geltungsbereichs: eigene Werte zuruecknehmen, CSS uebernimmt wieder.
      if (wurzel.style.getPropertyValue('--kopf-leiste-links')) {
        wurzel.style.removeProperty('--kopf-leiste-links');
        wurzel.style.removeProperty('--kopf-leiste-rechts');
        wurzel.style.removeProperty('--kopf-gruppe-versatz');
      }
      return;
    }
    const hb = m.header.getBoundingClientRect();
    const lb = m.leiste.getBoundingClientRect();

    // Fuer die Mitte zaehlt das SICHTBARE: von der Lupe bis zum Warenkorb-Zeichen, nicht
    // die Kastenbreite der Leiste (sie traegt links und rechts unsichtbaren Innenrand).
    // NUR Zeichen INNERHALB der Leiste: In ihr steckt auch das Suchfenster mit seinem
    // Schliessen-Zeichen, das ganz woanders liegt - damit kam eine Breite von ueber 1300px
    // heraus und der Versatz stand auf 703px statt rund 100px.
    const glyphen = Array.from(m.leiste.querySelectorAll('svg'))
      .map((s) => s.getBoundingClientRect())
      .filter((g) => g.width > 0 && g.height > 0 && g.left >= lb.left - 2 && g.right <= lb.right + 2);
    const sichtbareBreite = glyphen.length
      ? Math.max(...glyphen.map((g) => g.right)) - Math.min(...glyphen.map((g) => g.left))
      : lb.width;

    // Gerechnet wird NUR aus Groessen, die von der Verschiebung unabhaengig sind:
    // Menuebreite, Headerbreite, Menueabstand, sichtbare Symbolbreite.
    // Wer stattdessen die aktuelle Menuelage misst und daraus neu verschiebt, baut eine
    // Rueckkopplung: Beim ersten Versuch wanderte die Gruppe mit jedem Bild weiter nach
    // links, bei 1280px bis auf -332px - aus dem Fenster heraus.
    //   Gruppe = Menuebreite + Abstand + sichtbare Symbolbreite
    //   Das Menue steht ohne Zutun mittig, also (Header - Menuebreite) / 2.
    //   Ziel ist (Header - Gruppe) / 2  ->  Versatz = (Abstand + Symbolbreite) / 2
    //   Die Leiste beginnt am Menueende + Abstand, abzueglich des Innenrands des Symbols.
    const gruppe = m.menueBreite + m.abstand + sichtbareBreite;
    const versatz = (m.abstand + sichtbareBreite) / 2;
    const links = (hb.width - gruppe) / 2 + m.menueBreite + m.abstand - m.glypheOffset;

    const altLinks = parseFloat(wurzel.style.getPropertyValue('--kopf-leiste-links')) || null;
    const altVersatz = parseFloat(wurzel.style.getPropertyValue('--kopf-gruppe-versatz')) || null;
    if (altLinks === null || Math.abs(altLinks - links) > 0.5) {
      wurzel.style.setProperty('--kopf-leiste-links', links.toFixed(2) + 'px');
      // Zwei Anker wuerden die Leiste dehnen: Sobald links gemessen ist, faellt rechts weg.
      // Bewusst HIER und nicht in base.css - laeuft das Skript nicht, bleibt der rechte
      // Anker aus dem CSS stehen und die Leiste sitzt wie bisher.
      wurzel.style.setProperty('--kopf-leiste-rechts', 'auto');
    }
    if (altVersatz === null || Math.abs(altVersatz - versatz) > 0.5) {
      wurzel.style.setProperty('--kopf-gruppe-versatz', versatz.toFixed(2) + 'px');
    }
  };

  let geplant = false;
  const planen = () => {
    if (geplant) return;
    geplant = true;
    requestAnimationFrame(() => { geplant = false; setzen(); });
  };

  planen();
  window.addEventListener('resize', planen);
  window.addEventListener('load', planen);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(planen);
  // Menuepunkte koennen nachtraeglich dazukommen (Theme-Editor).
  const kopf = document.querySelector('.header');
  if (kopf) new MutationObserver(planen).observe(kopf, { childList: true, subtree: true });
})();
